/**
 * 侧栏「菜单为空」到底该画什么 —— 三种结局，一个判据，展开态/折叠态共用。
 *
 * - `loading`：loadUserMenus 在途（authSlice pending 置 isLoading=true、error=null），
 *   menuTree 还是初始 []。这一瞬**什么都不画**：2026-09-03 prod 前置 review 发现每个
 *   正常用户每次刷新都会先闪一下「等待管理员配置权限」——因为旧判据只看 length。
 * - `error`：菜单请求真失败（error 非空），给重试入口。
 * - `empty`：请求成功但确实没有菜单（已归属但没配角色），只提示等管理员，不给按钮。
 * - `null`：有菜单，正常渲染。
 */
export type MenuEmptyKind = "loading" | "error" | "empty" | null

export function resolveMenuEmptyKind(
  menuTree: readonly unknown[] | null | undefined,
  loading: boolean,
  error: string | null | undefined,
): MenuEmptyKind {
  if (menuTree && menuTree.length > 0) return null
  if (loading) return "loading"
  if (error) return "error"
  return "empty"
}
